module.exports = __webpack_public_path__ + "static/104930174_662805111244463_4876775302529081749_o_optimized-ab4ca8df781cba94a276dbbf044dc108.jpg";